import { SvgIcon, SvgIconProps } from '@mui/material'

const RemidIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path
        d="M12 2a7 7 0 0 0-7 7v10h14V9a7 7 0 0 0-7-7Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.75A6.25 6.25 0 0 0 5.75 9v9.25h12.5V9A6.25 6.25 0 0 0 12 2.75Zm7.75 15.5V9a7.75 7.75 0 0 0-15.5 0v9.25H2a.75.75 0 0 0 0 1.5h20a.75.75 0 0 0 0-1.5h-2.25Z"
        fill="currentColor"
      />
      <path
        d="M12 22a2.5 2.5 0 0 0 2.5-2.5V19h-5v.5A2.5 2.5 0 0 0 12 22Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.75 19a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 .75.75v.5a3.25 3.25 0 0 1-6.5 0V19Zm1.518.75a1.75 1.75 0 0 0 3.464 0h-3.464Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default RemidIcon
